import { Flex, Box, useToast } from '@chakra-ui/core';
import React from 'react';
import { FaRegCopy } from 'react-icons/fa';
import { Cell } from 'react-table';
import { useTranslation } from 'react-i18next';
import { FormattedTodo } from '../../types';
import colors from '../../../../styles/colors';
import { useStoreActions } from '../../../../models/hooks';

interface CandidateNameProps {
  cellData: Cell<FormattedTodo, any>;
}

export const CandidateName = React.memo(function CandidateName({ cellData }: CandidateNameProps) {
  const { t } = useTranslation();
  const toast = useToast();
  const columnData = cellData.row.original;

  const { setOpenCandidateMessagingModal, setMessagingViewModal, setSelectedCandidate } = useStoreActions(
    (actions) => actions.todo,
  );

  const onActionModalOpen = (candidateId: string) => {
    setSelectedCandidate(candidateId);
    setMessagingViewModal(false);
    setOpenCandidateMessagingModal(true);
  };

  const onCopyURL = async (candidateId: string) => {
    await navigator.clipboard.writeText(`${window.location.origin}/candidate/${candidateId}/messaging`);
    toast({
      title: t('toDoList:urlCopiedInfo'),
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Flex
      className={cellData.column.id}
      data-testid={cellData.column.id}
      alignItems="center"
      flex={1}
      justifyContent="space-between"
    >
      <Box
        as="span"
        style={{ color: colors.linkBlue, textDecoration: 'underline' }}
        cursor="pointer"
        mr={3}
        onClick={() => onActionModalOpen(columnData.candidateId)}
      >
        {cellData.value}
      </Box>

      <FaRegCopy
        style={{ minWidth: '18px' }}
        width={18}
        size={18}
        onClick={() => onCopyURL(columnData.candidateId)}
        data-testid={`RefreshButton-${columnData.candidateId}`}
      />
    </Flex>
  );
});
